import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useDialogLoadingButton } from '../_hooks/useDialogLoadingButton';
import { IAlertDialogProps } from './AlertDialog.interface';

export const AlertDialog: FunctionComponent<IAlertDialogProps> = (props) => {
  const { open, payload, onClose } = props;

  const { t } = useTranslation();

  const {
    title,
    msg,
    okText = t('text:common.button.ok'),
  } = payload;

  const okButtonProps = useDialogLoadingButton(() => onClose());

  return (
    <Dialog
      maxWidth={'xs'}
      fullWidth={true}
      open={open}
      onClose={() => onClose()}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{msg}</DialogContent>
      <DialogActions>
        <Button disabled={!open} {...okButtonProps}>
          {okText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
